"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRAVEL_DOC_OPTIONS_ONE = exports.TRAVEL_DOC_OPTIONS = exports.TRANSLATION = exports.INITIAL_VALUES = exports.FIELDS = exports.DEFAULT_DOC_TYPE = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var TRANSLATION = {
  passportDetails: 'Passport details',
  passportNumber: 'Passport number',
  expiryDate: 'Expiry date(Optional)',
  expiredError: 'Passport is expired',
  requiredError: 'Field is empty',
  maxLengthError: 'Max allowed charaters is {max}.',
  type: 'Travel Document Type',
  nationalId: 'National ID',
  docNumber: 'Document number',
  dateError: "That\u2019s an invalid date",
  passport: 'Passport'
};
exports.TRANSLATION = TRANSLATION;
var FIELDS = {
  passportNumber: {
    label: TRANSLATION.passportNumber,
    name: 'passportNumber'
  },
  expiryDate: {
    label: TRANSLATION.expiryDate,
    name: 'expiryDate'
  },
  type: {
    label: TRANSLATION.type,
    name: 'type'
  },
  docNumber: {
    label: TRANSLATION.docNumber,
    name: 'docNumber'
  }
};
exports.FIELDS = FIELDS;
var INITIAL_VALUES = _objectSpread({}, Object.keys(FIELDS).reduce(function (acc, curr) {
  acc[curr] = '';
  return acc;
}, {}));
exports.INITIAL_VALUES = INITIAL_VALUES;
var TRAVEL_DOC_OPTIONS = [{
  label: TRANSLATION.passport,
  value: 'passport'
}, {
  label: TRANSLATION.nationalId,
  value: 'id'
}];
exports.TRAVEL_DOC_OPTIONS = TRAVEL_DOC_OPTIONS;
var DEFAULT_DOC_TYPE = {
  label: TRANSLATION.passport,
  value: 'passport'
};
exports.DEFAULT_DOC_TYPE = DEFAULT_DOC_TYPE;
var TRAVEL_DOC_OPTIONS_ONE = [DEFAULT_DOC_TYPE];
exports.TRAVEL_DOC_OPTIONS_ONE = TRAVEL_DOC_OPTIONS_ONE;